__webpack_require__.p = "/apps/terms_of_service/js/";